import React, { useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import {
    setDateTimeFormatGlobal, getProcessButtons, getError, getLanguageObj, getResponse, isUndNullEmpNew, sendMessageCloseCurrentWindow,
    settings
} from '../../helpers/UtilsHelper'
import HtmlParser from 'react-html-parser';
import { RoleClass } from '../../classes/role/roleClass';
import { AuthContextType } from '../../auth/AuthContext';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { RoleService } from '../../services/roles/RoleService';

const { images, labels, messages, firebase, icons, } = settings
const { fields: dbFields, } = firebase?.firestore;

const currentMethod = 'RoleAddEditDetails - function';

export default function RoleAddEditDetails({
    $ = {},
    auth = AuthContextType,
    role = RoleClass?.getClass(),
    setRole = () => { },
    showModal = false,
    setShowModal = () => { },
    dtId = '',
    dtRowIndex = 0,
    setDtRowIndex = () => { },
    processType = 0,
    dateTimeFormat = { date: '', time: 0 },
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const [process, setProcess] = useState({ showLoading: false, save: false });
    const [errors, setErrors] = useState({ description: '' });
    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    const formDataValidate = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const thisFieldRequired = messages?.thisFieldRequired?.[languageObj?.id];
            const errors_ = { description: '' };

            if (isUndNullEmpNew({ data: role?.description, subMethod: currentMethod })?.result) {
                errors_.description = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            setErrors(prev => ({ ...prev, description: errors_?.description }));
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const roleSave = async ({
        e = {},
        subMethod = ''
    }) => {
        const currentMethod = 'roleSave';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            response = formDataValidate({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            const token = auth?.account?.tokenVzLaML?.token;
            response = await RoleService.save({ role, token, processType, subMethod: currentMethod });

            if (!response?.isSuccess || response?.isWarning) return;

            const roleLocal = response?.result || {};
            setRole(roleLocal);

            //#region update data table
            const dtRow = [
                roleLocal?.description,
                setDateTimeFormatGlobal({
                    date: roleLocal?.created,
                    type: dateTimeFormat?.date,
                    format: dateTimeFormat?.time,
                    addTime: false,
                    withSeconds: false,
                    subMethod
                })?.result,
                getProcessButtons({
                    id: roleLocal?.id,
                    description: roleLocal?.description,
                    detailsShow: false,
                    detailsLabel: labels?.detail?.[languageObj?.id],
                    detailsEnabled: false,
                    editShow: true,
                    editLabel: labels?.edit?.[languageObj?.id],
                    editEnabled: true,
                    deleteShow: true,
                    deleteLabel: labels?.delete?.[languageObj?.id],
                    deleteEnabled: true,
                    buttonsProcess: [],
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
            ];

            const dt = $(`#${dtId}`).DataTable();
            if (processType === 0) {
                dt.row.add(dtRow).draw();
            } else {
                dt.row(dtRowIndex).data(dtRow).draw();
            }
            //#endregion update data table

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}`;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setRole({});
                setDtRowIndex(0);
                setShowModal(false);
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    };

    const setFormValue = ({ key, value }) => {
        setRole(prev => ({ ...prev, [key]: value }));
        if (key === dbFields?.description && value?.trim() !== '') {
            setErrors(prev => ({ ...prev, description: '' }));
        }
    };

    useEffect(() => {
        isMount.current = true;
        setErrors({ description: '' });
        return () => {
            isMount.current = false;
        }
    }, [showModal]);
    //#endregion methods

    return (
        <Modal id='roleEditModal'
            backdrop='static'
            onHide={() => setShowModal(false)}
            show={showModal}
            centered
            contentClassName='border-0 shadow-lg login-card'>
            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt='imgRole' src={images?.roles} style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.role?.[languageObj?.id]}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className={`badge badge-pill py-1 px-2 text-uppercase ${processType === 0 ? 'badge-info' : processType === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`}
                            style={settings?.html?.badges?.micro}>
                            {processType === 0 ? labels?.add?.[languageObj?.id] :
                                processType === 1 ? labels?.edit?.[languageObj?.id] :
                                    labels?.detail?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <form onSubmit={(e) => roleSave({ e: e, subMethod: 'from - onSubmit' })} method='post'>
                <Modal.Body className='px-4 pt-2'>
                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.description?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.userCog} position-absolute input-icon-left`} />
                            <input className='form-control border-0 shadow-sm form-input-icon'
                                onChange={(e) => setFormValue({ key: dbFields?.description, value: e?.target?.value, subMethod: 'inputDescription' })}
                                placeholder={labels?.description?.[languageObj?.id]}
                                title={labels?.description?.[languageObj?.id]}
                                type='text'
                                onFocus={() => setErrors(prev => ({ ...prev, description: '' }))}
                                value={role?.description || ''}>
                            </input>
                        </div>
                        {errors && <div className={settings?.html?.errorText}>{HtmlParser(errors?.description || '')}</div>}
                    </div>
                </Modal.Body>

                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4 btn-primary'
                            data-title={labels?.save?.[languageObj?.id]}
                            disabled={process?.showLoading}
                            type='submit'>
                            {!process?.save ? (
                                <i className={`${icons?.fasFa?.save} mr-1`} />
                            ) : (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            )} {labels?.save?.[languageObj?.id]}
                        </button>
                        <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                            data-title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => setShowModal(false)}>
                            <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`} /> {labels?.close?.[languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}